export enum COLORS {
  PURPLE = 'purple',
  BLUE = 'blue',
  TEAL = 'teal',
  ORANGE = 'orange',
  DARK_CYAN = 'darkcyan',
  PINK = 'pink',
  LIGHT_BLUE = 'lightblue',
  MAGENTA = 'magenta',
  ULTRALIGHT_BLUE = 'lightblue-light-2',
  DARK_MAGENTA = 'magenta-dark-1',
  DARK_BLUE = 'blue-dark-1',
  DARK_PURPLE = 'purple-dark-1',
}

export enum COLORS_HEX {
  DARK_CYAN = '#17BAC5',
  TEAL = '#1AE6E0',
  LIGHT_BLUE = '#79CFFF',
  BLUE = '#5272E4',
  PURPLE = '#C780FF',
  MAGENTA = '#FF35B7',
  ORANGE = '#FF965C',
  PINK = '#FFA3E6',
  ULTRALIGHT_BLUE = '#CCE9FF',
  DARK_PURPLE = '#B62CFF',
  DARK_MAGENTA = '#B5007E',
  DARK_BLUE = '#2C4CAB',
}

export enum CHART_COLORS {
  PURPLE = 'purple',
  BLUE = 'blue',
  TEAL = 'teal',
  ORANGE = 'orange',
  DARK_CYAN = 'darkcyan',
  PINK = 'pink',
  LIGHT_BLUE = 'lightblue',
  MAGENTA = 'magenta',
  ULTRALIGHT_BLUE = 'lightblue-light-2',
  DARK_MAGENTA = 'magenta-dark-1',
  DARK_BLUE = 'blue-dark-1',
  DARK_PURPLE = 'purple-dark-1',
}

export enum CHART_COLORS_HEX {
  PURPLE = '#C780FF',
  BLUE = '#5272E4',
  TEAL = '#1AE6E0',
  ORANGE = '#FF965C',
  DARK_CYAN = '#17BAC5',
  PINK = '#FFA3E6',
  LIGHT_BLUE = '#79CFFF',
  MAGENTA = '#FF35B7',
  ULTRALIGHT_BLUE = '#CCE9FF',
  DARK_MAGENTA = '#B5007E',
  DARK_BLUE = '#2C4CAB',
  DARK_PURPLE = '#B62CFF',
  POSITIVE = '#35CB00',
  NEGATIVE = '#FF2B00',
}
